import { Box, Button } from '@mui/material';
import { useLayoutEffect, useRef, useState } from 'react';

const OverflowBox = ({ children, rowHeight, boxProps, buttonProps }) => {
  const [maxHeight, setMaxHeight] = useState(rowHeight);
  const [hasOverflow, setHasOverflow] = useState(false);
  const ref = useRef(null);

  useLayoutEffect(() => {
    if (ref?.current?.scrollHeight > rowHeight) {
      setHasOverflow(true);
    }
    if (ref?.current?.scrollHeight === rowHeight) {
      setHasOverflow(false);
    }
  }, [ref?.current?.scrollHeight, rowHeight, setHasOverflow, setMaxHeight, maxHeight]);

  return (
    <Box
      flex={[1, 1]}
      overflow="hidden"
      position="relative"
      ref={ref}
      maxHeight={maxHeight}
      flexWrap="wrap"
      display="flex"
      flexDirection="row"
      {...boxProps}>
      {children}
      {hasOverflow && maxHeight === rowHeight && (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: 1,
          }}>
          <Box
            sx={{
              height: rowHeight,
              width: 100,
              background:
                'linear-gradient(to right, rgba(0, 0, 0, 0), rgba(255, 255, 255, 1))',
            }}
          />
          <Button
            size="small"
            variant="contained"
            onClick={() => setMaxHeight(null)}
            {...buttonProps}>
            More
          </Button>
        </Box>
      )}
      {hasOverflow && maxHeight !== rowHeight && (
        <Button
          size="small"
          variant="contained"
          onClick={() => setMaxHeight(32)}
          {...buttonProps}>
          Less
        </Button>
      )}
    </Box>
  );
};

export default OverflowBox;
